<template>
    <va-edit-layout>
        <CatalogItem-form
            :id="id"
            :title="title"
            :item="item"
        ></CatalogItem-form>
    </va-edit-layout>
</template>

<script>
export default {
    props: ["id", "title", "item"],
};
</script>
